/**************************************************
 * Nombre:       Formulario_Video_YouTube
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {LinkRounded, TitleOutlined} from "@mui/icons-material";

const Formulario_Video_YouTube = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imange del video opcional</Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del Video'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={LinkRounded} nombre={'Link del video'} dato={'link'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Video_YouTube